var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalleticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8,1.2c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9H3.4c-0.9,0-1.6,0.7-1.6,1.6v10.6c0,0.9,0.7,1.6,1.6,1.6h13.1 c0.9,0,1.6-0.7,1.6-1.6V8.4c0-0.9-0.7-1.6-1.6-1.6H4.7c-0.5,0-0.9-0.4-0.9-0.9S4.2,5,4.7,5h11.9C18.5,5,20,6.5,20,8.4v6.9 c0,1.9-1.5,3.4-3.4,3.4H3.4c-1.9,0-3.4-1.5-3.4-3.4V4.7c0-1.9,1.5-3.4,3.4-3.4H17.8z M13.8,11.9c0-0.7,0.6-1.2,1.2-1.2 s1.2,0.6,1.2,1.2s-0.6,1.2-1.2,1.2S13.8,12.6,13.8,11.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalleticon);
export default __webpack_public_path__ + "static/media/walleticon.37fc8e3e.svg";
export { ForwardRef as ReactComponent };